import React, { createContext, useContext, useState, useCallback } from 'react';

// Create Loading Context
const LoadingContext = createContext();

// Loading Provider Component
export const LoadingProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState('');

  const setLoading = useCallback((loading) => {
    setIsLoading(loading);
  }, []);

  const setGlobalLoadingMessage = useCallback((message) => {
    setLoadingMessage(message);
  }, []);

  const value = {
    isLoading,
    loadingMessage,
    setLoading,
    setLoadingMessage,
    setGlobalLoadingMessage
  };

  return (
    <LoadingContext.Provider value={value}>
      {children}
    </LoadingContext.Provider>
  );
};

// Custom hook to use loading context
export const useLoading = () => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error('useLoading must be used within a LoadingProvider');
  }
  return context;
};

export default LoadingContext;
